module.exports = __webpack_public_path__ + "static/media/user-nurse.d4452a88.svg";